<div id="disclaimer" *ngIf="showDisclaimer$ | async" class="sh-fixed-footer">
    <div *ngIf="disclaimerContent$ | async as disclaimerContent; else disclaimerError" class="sh-notice-panel">
        <h4 class="sh-notice-panel__title">
            <sh-html-parser [message]="disclaimerContent.title"></sh-html-parser>
        </h4>
        <div class="sh-notice-panel__content">
            <div *ngFor="let section of disclaimerContent.sections">
                <h5 *ngIf="section.sectionTitle">
                    <sh-html-parser [message]="section.sectionTitle"></sh-html-parser>
                </h5>
                <p *ngFor="let paragraph of section.paragraphs">
                    <span [innerHtml]="paragraph"></span>
                </p>
            </div>
            <ul class="sh-action-group -sh-align-end">
                <li *ngIf="disclaimerLink$ | async as link" class="sh-action-group__item">
                    <sh-action-item [item]="link" class="sh-action-group__item__action"></sh-action-item>
                </li>
                <li *ngIf="acceptButton$ | async as acceptButton" class="sh-action-group__item">
                    <sh-action-item [item]="acceptButton" class="sh-action-group__item__action"></sh-action-item>
                </li>
            </ul>
        </div>
    </div>
</div>

<ng-template #disclaimerError>
    <div class="sh-notice-panel">
        <div class="sh-notice-panel__content">
            <sh-notification [type]="notificationType.Error" [message]="'errors.translation-not-found' | translate" [icon]="'delete'"></sh-notification>
        </div>
    </div>
</ng-template>
